@use "../../styles/mixins/component-wrapper" as wrapper;

$icon-font-family: "Allianz Icons";

@include wrapper.layered-component {
  .icon {
    font-family: var(--semantic-font-family-body);
    font-style: normal;
    display: contents;

    &::before {
      font-family: $icon-font-family;
      font-size: var(--semantic-size-content-m);
    }

    // Base styles for each type in regular state (not inverse, not disabled)
    &.primary {
      color: var(--semantic-color-on-surface-primary-resting);
    }

    &.secondary {
      color: var(--semantic-color-on-surface-secondary-resting);
    }

    &.critical {
      color: var(--semantic-color-signal-attention-critical-resting);
    }

    &.info {
      color: var(--semantic-color-signal-attention-info-resting);
    }

    &.positive {
      color: var(--semantic-color-signal-attention-positive-resting);
    }

    &.warning {
      color: var(--semantic-color-signal-attention-warning-resting);
    }

    // Inverse styles for each type (not disabled)
    &.inverse {
      &.primary {
        color: var(--semantic-color-on-surface-primary-inverse-resting);
      }

      &.secondary {
        color: var(--semantic-color-on-surface-secondary-inverse-resting);
      }

      &.critical {
        color: var(--semantic-color-signal-attention-inverse-critical-resting);
      }

      &.info {
        color: var(--semantic-color-signal-attention-inverse-info-resting);
      }

      &.positive {
        color: var(--semantic-color-signal-attention-inverse-positive-resting);
      }

      &.warning {
        color: var(--semantic-color-signal-attention-inverse-warning-resting);
      }
    }

    &.disabled {
      cursor: not-allowed;

      // Disabled styles for each type (not inverse)
      &.primary,
      &.secondary {
        color: var(--semantic-color-on-surface-primary-disabled);
      }

      &.critical,
      &.info,
      &.positive,
      &.warning {
        color: var(--semantic-color-signal-attention-disabled);
      }

      // Disabled + inverse styles
      &.inverse {
        &.primary,
        &.secondary {
          color: var(--semantic-color-on-surface-primary-inverse-disabled);
        }

        &.critical,
        &.info,
        &.positive,
        &.warning {
          color: var(--semantic-color-signal-attention-inverse-disabled);
        }
      }
    }

    &.functional,
    &.critical,
    &.info,
    &.positive,
    &.warning {
      &.s {
        &::before {
          font-size: var(--semantic-size-content-s);
        }
      }

      &.m {
        &::before {
          font-size: var(--semantic-size-content-m);
        }
      }
    }

    &.file {
      display: block;
      position: relative;

      &.inverse > .file-icon-box {
        background-color: var(--semantic-color-signal-attention-inverse-info-resting);
      }

      &.s {
        width: var(--semantic-size-content-s);
        height: var(--semantic-size-content-s);

        &::before {
          font-size: var(--semantic-size-content-s);
        }

        & > .file-icon-box {
          background-color: #96dcfa; /* no semantic color found in the token set */
          color: #5a3982; /* no semantic color found in the token set */
          display: block;
          text-transform: uppercase;
          font-size: 5px; /* no definition present in the token set */
          padding: 1px 2px 2px 4px; /* no definition present in the token set */
          position: absolute;
          top: 8px; /* no definition present in the token set */
          left: 1px;
          border-radius: 2px 0 0 2px; /* no definition present in the token set */
        }
      }

      &.m {
        width: var(--semantic-size-content-m);
        height: var(--semantic-size-content-m);

        &::before {
          font-size: var(--semantic-size-content-m);
        }

        & > .file-icon-box {
          background-color: #96dcfa; /* no semantic color found in the token set */
          color: #5a3982; /* no semantic color found in the token set */
          display: block;
          text-transform: uppercase;
          font-size: 7px; /* no definition present in the token set */
          padding: 1px 2px 2px 4px;
          position: absolute;
          top: 9px; /* no definition present in the token set */
          left: 1px;
          border-radius: 2px 0 0 2px; /* no definition present in the token set */
        }
      }
    }

    &.illustrative {
      color: var(--semantic-color-on-surface-primary-resting);

      &.contained {
        border-radius: var(--semantic-border-radius-round);
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        &--default {
          background-color: var(--semantic-color-surface-default-resting);

          &.inverse {
            background-color: var(--semantic-color-surface-default-inverse-resting);
          }

          &.disabled {
            background-color: var(--semantic-color-surface-default-disabled);

            &.inverse {
              background-color: var(--semantic-color-surface-default-inverse-disabled);
            }
          }
        }

        &--emphasis {
          background-color: var(--semantic-color-surface-emphasis-resting);

          &.inverse {
            background-color: var(--semantic-color-surface-emphasis-inverse-resting);
          }

          &.disabled {
            background-color: var(--semantic-color-surface-emphasis-disabled);

            &.inverse {
              background-color: var(--semantic-color-surface-emphasis-inverse-disabled);
            }
          }
        }

        &.l {
          width: var(--semantic-size-component-l);
          height: var(--semantic-size-component-l);

          &::before {
            font-size: var(--icon-illustrative-contained-l-size);
            vertical-align: middle;
          }
        }

        &.xl {
          width: var(--semantic-size-component-xl);
          height: var(--semantic-size-component-xl);

          &::before {
            font-size: var(--icon-illustrative-contained-xl-size);
            vertical-align: middle;
          }
        }
      }

      &.inverse {
        color: var(--semantic-color-on-surface-primary-inverse-resting);
      }

      &.disabled {
        color: var(--semantic-color-on-surface-primary-disabled);
      }
    }

    &.l {
      &::before {
        font-size: var(--semantic-size-content-l);
      }
    }

    &.xl {
      &::before {
        font-size: var(--semantic-size-content-xl);
      }
    }
  }
}
